import CyclingCache from "../cache/CyclingCache";

/**
 * @abstract
 */
export default class EffectCache extends CyclingCache {
    constructor() {
        super();
        /**
         * @constant
         * @type {number}
         */
        this.initialCacheSize = 20;
        /**
         * @constant
         * @type {number}
         */
        this.growAmount = 10;
    }

    /**
     * @override
     * @returns {number}
     */
    getGrowAmount() {
        return this.growAmount;
    }

    /**
     * @override
     * @returns {number}
     */
    getInitialSize() {
        return this.initialCacheSize;
    }

}